import React from 'react';
import {useTranslation} from 'react-i18next';
import {Warning} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import {Colors} from '../../styles/Colors';
import { DialogInterface } from '../../components/Extensions/types/dialog';
import AlertDialog from '../../components/AlertDialog/AlertDialog';
import { DialogButton } from '../../components/AlertDialog/DialogContainer';

const useStyles = makeStyles(() => ({
    dialogContainer: {
        '& .MuiPaper-root': {
            width: 640,
        },
    },

    content: {
        '& .MuiTypography-root': {
            display: 'flex',
            alignItems: 'center',
        },

        '& svg > path': {
            fill: Colors.Gray5,
        },

        '& svg': {
            marginRight: 17,
        },
    },
}));

const CreateNewProfileErrorDialog: React.FC<DialogInterface> = (
    {
        isOpen,
        toggleVisibility
    }) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const handleClick = () => {
        toggleVisibility?.();
    };

    const description = (
        <>
            <Warning/>
            {t('errors:deviceProfiles.youCantCreateProfileForThisModel')}
        </>
    );

    return (
        <AlertDialog
            isOpen={isOpen}
            header={t('screens:deviceProfiles.addNewDeviceProfile')}
            description={description}
            contentClass={classes.content}
            className={classes.dialogContainer}
            dialogActionsButtons={
                <DialogButton
                    key="cancel"
                    label={t('common:close')}
                    onClick={handleClick}
                    primary
                />
            }
        />
    );
};

export default CreateNewProfileErrorDialog;
